import { ButtonTypeStyles, ButtonSizeStyles } from './types';

export const BUTTON_STYLES: ButtonTypeStyles = {
  primary: {
    background: 'primary500',
    hover: 'primary600',
    active: 'primary700',
    content: 'white',
    boxShadow: '0px -2px 0px 0px rgba(0, 0, 0, 0.10) inset',
  },
  secondary: {
    background: 'white',
    border: 'primary500',
    hover: 'primary100',
    active: 'primary200',
    content: 'primary500',
  },
  secondaryBlue: {
    background: 'white',
    border: 'blue500',
    hover: 'blue100',
    content: 'blue500',
    active: 'blue200',
  },
  tertiary: {
    background: 'white',
    border: 'grey100',
    hover: 'grey050',
    active: 'grey075',
    content: 'grey700',
  },
  primaryText: {
    background: 'transparent',
    hover: 'primary100',
    active: 'primary200',
    content: 'primary500',
  },
  secondaryText: {
    background: 'transparent',
    hover: 'grey050',
    active: 'grey075',
    content: 'grey700',
  },
  primaryDestructive: {
    background: 'red500',
    hover: 'red600',
    active: 'red700',
    content: 'white',
    boxShadow: '0px -2px 0px 0px rgba(0, 0, 0, 0.10) inset',
  },
  secondaryDestructive: {
    background: 'white',
    border: 'red500',
    hover: 'red100',
    active: 'red200',
    content: 'red500',
  },
  textDestructive: {
    background: 'transparent',
    hover: 'red100',
    active: 'red200',
    content: 'red500',
  },
  primaryGreen: {
    background: 'green500',
    hover: 'green600',
    active: 'green700',
    content: 'white',
    boxShadow: '0px -2px 0px 0px rgba(0, 0, 0, 0.10) inset',
  },
};

export const BUTTON_SIZES: ButtonSizeStyles = {
  regular: {
    padding: '8px 12px',
    height: '36px',
    fontSize: '14px',
    iconSize: '20px',
  },
  mini: {
    padding: '0px 12px',
    height: '24px',
    fontSize: '12px',
    iconSize: '16px',
  },
};
